import React from 'react';
import { useEffect, useState } from 'react';
import { Chart as ChartJS, BarElement, CategoryScale,LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Axios from '../../../../services/AxiosInstance';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
);


export default function MonthWiseRegReport() {
  const [chart, setChart] = useState({})




  
  useEffect(() => {
    const fetchCoins  = async () => {
      Axios.get("api/admin/reports/month-wise-reg-report")
      .then((res)=>{
        setChart(res.data)
      }).catch((e)=>{
        console.log(e);
      })
       
    };
    fetchCoins();
}, [])
 
  var data = {
    // labels: ['Red', 'Blue','Yellow','Green', 'purple', 'orange'],
    labels: chart?.data?.map(x => x.month),
    datasets: [{
      label: `${chart?.data?.length} products Available`,
      data: chart?.data?.map(x => x.no_of_reg),
      // label: `# of votes`,
      // data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 1
    }]
  };

  var options = {
    maintainAspectRatio: false,
    scales: {
    },
    legend: {
      labels: {
        fontSize: 15,
      },
    },
  }

  return (
    <div className=''
    
    
    >
      <Bar
        data={data}
        height={400}
        options={options}

      />
    </div>
  )
}
